import styled from "styled-components";

export const Image = styled.img`
    width:158px;
    height: 38px;
    cursor: pointer;
    &.footer{
        width: 103px;
        height: 25px;
        opacity: .5;
    }
`;